<template>
  <div class="detail_box">

    <div class="big_box">

      <div class="breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="background:#fff;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/news'}">资讯动态</el-breadcrumb-item>
          <el-breadcrumb-item>新闻</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="detailCon_box" >
        <div class="detail_con">
          <h1>{{conList.str_news_title}}</h1>
          <p class="time">{{conList.str_show_time}}</p>
          <div class="article" v-html="conList.str_content_info">{{conList.str_content_info}}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "news",
  data () {
    return {
      conList:'',
      listId:''
    }
  },
  created(){
    this.$parent.activeIndex = 'detail'
    this.wnlSliderLastFn(this.listId)
  },
  methods:{
    wnlSliderLastFn(id){
      this.listId = this.$route.query.id
      this.axios.post(
				process.env.API_HOST + '/newsdetial',
				this.$qs.stringify({"id":this.listId})
			)
			.then( res => {
        this.conList = res.data.msg
			})
			.catch(error => {
				this.$toast("网络错误，不能访问");
			})
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/news") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
}
</script>

<style scoped>
/* .detail_box{
  background: #f8f9fd;
} */
.detail_box{
  display: inline-table;
  width: 100%;
  background-color: #fff ;
}
.big_box{
  width: 1140px;
  margin: 0 auto;
}
.breadcrumb_box {
  font-size: 20px;
  color: #666666;
  margin: 50px 0 80px;
  position: relative;
}
.backBtn{
  position: absolute;
  top: -15px;
  right: 50px;
  width: 80px;
  line-height: 40px;
  font-size: 18px;
  background: #658e31;
  color: #fff;
  border: none;
  border-radius: 10px;
  letter-spacing: 3px;
}
.detailCon_box{
  width: 880px;
  margin: 0 auto;
}
.detail_con h1{
  font-size: 44px;
  color: #333333;
  font-weight: 500;
  text-align: left;
  margin-bottom: 50px;
  line-height: 60px;
}
.detail_con .time{
  font-size: 12px;
  color: #666666;
  margin-bottom: 70px;
}
.detail_con .article{
  font-size: 18px;
  line-height: 40px;
  color: #333333;
  margin-bottom: 100px;  
}
</style>



// WEBPACK FOOTER //
// src/components/page/Detail.vue